import styled from 'styled-components';
import tw from 'twin.macro';

import { SUCCESS_MESSAGE_BG_IMAGE_URL } from '../../constants/FormConstant';

export const MainContainer = styled.div`
  ${tw`flex flex-col items-center justify-center w-full`}
  background-image: url(${SUCCESS_MESSAGE_BG_IMAGE_URL});
  background-repeat: repeat;
  background-position: center;
  background-color: #ffffff;
`;

export const SuccessCardContainer = styled.div`
  ${tw`relative w-full flex flex-col items-center justify-center rounded-16px box-border`}
  min-height: 556px;
  width: 100%;
  max-width: 300px;
  gap: 24px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const IconWrapper = styled.div`
  ${tw`flex justify-center items-center`}
  flex-shrink: 0;
  width: auto;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TitleText = styled.p`
  ${tw`text-2xl leading-7 font-semibold text-center font-sans`}
  color: #334155;
  margin: 0;

  @media (max-width: 768px) {
    ${tw`text-lg leading-6`}
  }
`;

export const DescriptionText = styled.p`
  ${tw`text-sm leading-5 font-normal text-center font-inter`}
  color: #475569;
  margin: 0;
  max-width: 300px;
`;

export const CalendarTimeContainer = styled.div`
  ${tw`flex flex-col w-full rounded-12px`}
  background: #dbeafe;
  padding: 16px;
  gap: 7px;

  @media (max-width: 768px) {
    ${tw`flex-row items-center justify-center rounded-8px`}
    padding: 8px 16px;
    gap: 0;
  }
`;

export const CalendarTimeRow = styled.div`
  ${tw`flex items-center gap-2`}
  width: 100%;

  @media (max-width: 768px) {
    ${tw`flex items-center`}
    width: auto;
    gap: 8px;
    flex: 0 0 auto;
  }
`;

export const DividerLine = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    width: 0.5px;
    min-height: 20px;
    background: #94a3b8;
    margin: 0 7px;
    flex-shrink: 0;
  }
`;

export const DateText = styled.span`
  ${tw`text-base leading-7 font-semibold font-sans`}
  color: #0f172a;

  @media (max-width: 768px) {
    ${tw`text-xs font-inter`}
    color: #1e293b;
  }
`;

export const EBookImage = styled.img`
  ${tw`w-full rounded-4px`}
  height: auto;
  margin-top: 8px;
`;
